import "./adminCard.css";

// The one surface primitive. compact tightens padding for dense contexts
// (dashboard widgets); interactive adds a hover lift for clickable cards.
export const AdminCard = ({
  compact = false,
  interactive = false,
  className = "",
  children,
  ...rest
}) => (
  <div
    className={[
      "admin-card",
      compact ? "admin-card--compact" : "",
      interactive ? "admin-card--interactive" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
    {...rest}
  >
    {children}
  </div>
);
